<app-page-template
  [showParent]="showParent"
  (clearQueryString)="onClearQueryString()"
  [config]="pageConfig"
  (onAdd)="onCreate('', true)"
  (sortObject)="getSortItems($event)"
  (onShowAuditPage)="onShowAuditPage()"
  (onShowHelpPage)="onShowHelpPage()"
  (comparisonObjects)="getComparisonObjects($event)"
  (pageNumber)="changePageNumber($event)"
  (pageSize)="changePageSize($event)"
>
  <!--------------------------------------- Table Content --------------------------------------->
  <ng-container table-body *ngIf="(items$ | async) && !pageConfig.loading">
    <ng-container *ngFor="let item of items$ | async; let i = index">
      <tr
        #row
        (click)="onActiveRow(row, i)"
        [class.row-active]="rowIndexSelected == i"
      >
        <!-- index -->
        <td class="tw-text-center !tw-p-4">
          {{ paginationModel?.firstIndex + i }}
        </td>

        <!-- id -->
        <td>
          <td-value class="" copyToClipboard [value]="item?.id"></td-value>
        </td>

        <!-- title -->
        <td>
          <td-value copyToClipboard [value]="item?.title"></td-value>
        </td>

        <!-- smsText -->
        <td
          class="msg-summary tw-text-center"
          [ngClass]="{
            ' tw-cursor-pointer': item?.smsText
          }"
        >
          <div
            class="tw-flex-center"
            [hidePopover]="
              !showParent ||
              pageConfig?.isVisibleHelpPage ||
              pageConfig?.isVisibleAuditPage
            "
            textPopover
            [parentSelector]="tagName"
            [fullText]="item?.smsText"
          >
            <p
              class="tw-text-gray-500 dark:!tw-text-gray-200 tw-font-normal max-one-row tw-w-[100px] tw-min-w-[100px]"
            >
              {{ item?.smsText | checkValue }}
            </p>
          </div>
        </td>

        <!-- organizationName -->
        <td class="tw-p-2">
          <td-value
            copyToClipboard
            type="text"
            [value]="item?.organizationName"
          ></td-value>
        </td>

        <!-- sendType -->
        <td>
          <span [sendTypeStyle]="item?.sendType">{{
            item?.sendType | enumToText : SendTypesEnumValues
          }}</span>
          <!-- <i [sendTypeIcon]="modelItem?.sendType"></i> -->
        </td>

        <!-- sendSubType -->
        <td>
          <span [sendSubTypeStyle]="item?.sendSubType">{{
            item?.sendSubType | enumToText : SendSubTypesEnumValues
          }}</span>
        </td>

        <!-- created -->
        <td>
          <td-value type="dateTime" [value]="item?.created"></td-value>
        </td>

        <td class="sticky-td">
          <a mat-icon-button [matMenuTriggerFor]="menu">
            <i class="mdi mdi-dots-vertical text-navyBlue mdi-20px"></i>
          </a>

          <mat-menu #menu="matMenu" xPosition="before">
            <!-- select button -->
            <div
              mat-menu-item
              class="tw-flex-center text-navyBlue border-bottom"
              (click)="onSelect(item.id)"
              [matTooltip]="'common.select' | translate"
            >
              <i
                class="mdi mdi mdi-send mdi-20px tw-ml-[10px] ltr:tw-mr-[10px] text-navyBlue"
              ></i>
              <span class="mat-menu-title tw-font-medium">{{
                "common.send" | translate
              }}</span>
            </div>

            <!-- delete button -->
            <div
              mat-menu-item
              class="tw-flex-center text-danger border-bottom"
              (click)="onDelete(item.id, item?.title)"
              [matTooltip]="'common.delete' | translate"
            >
              <i
                class="mdi mdi mdi-trash-can-outline mdi-20px tw-ml-[10px] ltr:tw-mr-[10px] text-danger"
              ></i>
              <span class="mat-menu-title tw-font-medium">{{
                "common.delete" | translate
              }}</span>
            </div>
          </mat-menu>
        </td>
      </tr>
    </ng-container>
  </ng-container>
</app-page-template>

<!--------------------------------------- Audit --------------------------------------->

<ng-container *ngIf="pageConfig?.isVisibleAuditPage">
  <app-audit
    [service]="currentService"
    methodName="campaignsGetCampaignsAudit"
    (hidePage)="onHideAuditPage()"
  >
  </app-audit>
</ng-container>

<!--------------------------------------- help --------------------------------------->
<ng-container *ngIf="pageConfig?.isVisibleHelpPage">
  <app-help-page
    [menuTitle]="pageName"
    (hidePage)="onHideHelpPage()"
    [title]="pageConfig.title"
  >
  </app-help-page>
</ng-container>
